import { useState } from 'react';
import { Buttons, ChooseBrandsModels } from 'components';

const ChooseBrandsModelBtn = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Brand & Models
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ChooseBrandsModels
          isOpen={isOpen}
          close={() => setIsOpen(false)}
          title='Brands & Models'
        />
      )}
    </>
  );
};

export default ChooseBrandsModelBtn;
